import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CalendarLegend.module.scss';

const CalendarLegend: FC = () => {
  const { t } = useTranslation();

  const items = [
    { key: 'selected', dot: styles.DotSelected },
    { key: 'today', dot: styles.DotToday },
    { key: 'closed', dot: styles.DotClosed },
    { key: 'unavailable', dot: styles.DotUnavailable },
  ];

  return (
    <ul className={styles.Legend}>
      {items.map((item) => (
        <li className={styles.Item} key={item.key}>
          <span className={`${styles.Dot} ${item.dot}`} />
          <span className={styles.Label}>
            {t(`pages.ticketInformation.legend.${item.key}`)}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default CalendarLegend;
